import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/inquiry/Home.vue";
import SelectCar from "../views/inquiry/SelectCar.vue";
import ViolationInquiry from "../views/inquiry/ViolationInquiry.vue";
import ViolationInquiryAll from "../views/inquiry/ViolationInquiryAll.vue";
import CardSanadInquiry from "../views/inquiry/CardSanadInquiry.vue";
import ActivePlakInquiry from "../views/inquiry/ActivePlakInquiry.vue";
import LicenseStatusInquiry from "../views/inquiry/LicenseStatusInquiry.vue";
import LicenseNegativePointInquiry from "../views/inquiry/LicenseNegativePointInquiry.vue";
import TehranTolls from "../views/inquiry/TehranTolls.vue";
import AirPollutions from "../views/inquiry/AirPollutions.vue";
import AnnualToll from "../views/inquiry/AnnualToll.vue";
import FreewayTolls from "../views/inquiry/FreewayTolls.vue";
import Barcode from "../views/inquiry/Barcode.vue";
import Plate from "../views/inquiry/Plate.vue";
import Vin from "../views/inquiry/Vin.vue";
import TopUsers from "../views/core/TopUsers.vue";
import VehicleExaminationCenters from "../views/carService/VehicleExaminationCenters.vue";
import PlateReplacementCenters from "../views/carService/PlateReplacementCenters.vue";
import PetrolStations from "../views/carService/PetrolStations.vue";
import CarPriceList from "../views/carService/CarPriceList.vue";
import CarInfoHomePage from "../views/CarInfo/HomePage.vue";
import CarInfoBrand from "../views/CarInfo/brand.vue";
import CarInfoDetail from "../views/CarInfo/Detail.vue";
import ClubHome from "../views/club/Club.vue";
import ClubDetail from "../views/club/Detail.vue";
import ClubPrize from "../views/club/Prize.vue";
import ScoreDetail from "../views/club/ScoreDetail.vue";
import CarFinesServices from "../views/commingSoon/CarFinesServices.vue";
import FreewayTollsServices from "../views/commingSoon/FreewayTollsServices.vue";
import TehranTollsServices from "../views/commingSoon/TehranTollsServices.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/inquiry/select-car/:redirect",
    name: "SelectCar",
    component: SelectCar,
    props: true,
  },
  {
    path: "/inquiry/violation-inquiry/:carId/:newCar",
    name: "ViolationInquiry",
    component: ViolationInquiry,
    props: true,
  },
  {
    path: "/inquiry/violation-inquiry-all/:carId/:newCar",
    name: "ViolationInquiryAll",
    component: ViolationInquiryAll,
    props: true,
  },
  {
    path: "/inquiry/card-sanad-inquiry/:carId/:newCar",
    name: "CardSanadInquiry",
    component: CardSanadInquiry,
    props: true,
  },
  {
    path: "/inquiry/active-plak-inquiry",
    name: "ActivePlakInquiry",
    component: ActivePlakInquiry,
    props: true,
  },
  {
    path: "/inquiry/license-status-inquiry",
    name: "LicenseStatusInquiry",
    component: LicenseStatusInquiry,
    props: true,
  },
  {
    path: "/inquiry/license-negative-point-inquiry",
    name: "LicenseNegativePointInquiry",
    component: LicenseNegativePointInquiry,
    props: true,
  },
  {
    path: "/inquiry/tehran-tolls/:carId",
    name: "TehranTolls",
    component: TehranTolls,
    props: true,
  },
  {
    path: "/inquiry/air-pollutions/:carId",
    name: "AirPollutions",
    component: AirPollutions,
    props: true,
  },
  {
    path: "/inquiry/freeway-tolls/:carId",
    name: "FreewayTolls",
    component: FreewayTolls,
    props: true,
  },
  {
    path: "/inquiry/annual-tolls/:carId",
    name: "AnnualToll",
    component: AnnualToll,
    props: true,
  },
  {
    path: "/inquiry/barcode/:redirect/:carId",
    name: "Barcode",
    component: Barcode,
    props: true,
  },
  {
    path: "/inquiry/plate/:redirect/:carId",
    name: "Plate",
    component: Plate,
    props: true,
  },
  {
    path: "/inquiry/vin/:redirect/:carId",
    name: "Vin",
    component: Vin,
    props: true,
  },
  {
    path: "/club/top-users",
    name: "TopUsers",
    component: TopUsers,
    props: true,
  },
  {
    path: "/car-service/vehicle-examination-centers",
    name: "VehicleExaminationCenters",
    component: VehicleExaminationCenters,
    props: true,
  },
  {
    path: "/car-service/plate-replacement-centers",
    name: "PlateReplacementCenters",
    component: PlateReplacementCenters,
    props: true,
  },
  {
    path: "/car-service/petrol-stations",

    name: "PetrolStations",
    component: PetrolStations,
    props: true,
  },
  {
    path: "/car-service/car-price-list",
    name: "CarPriceList",
    component: CarPriceList,
    props: true,
  },
  {
    path: "/car-info/home",
    name: "CarInfoHome",
    component: CarInfoHomePage,
    props: false,
  },
  {
    path: "/car-info/brand/:brandId",
    name: "CarInfoBrand",
    component: CarInfoBrand,
    props: true,
  },
  {
    path: "/car-info/detail/:carId",
    name: "CarInfoDetail",
    component: CarInfoDetail,
    props: true,
  },
  {
    path: "/Club",
    name: "ClubHome",
    component: ClubHome,
  },
  {
    path: "/Detail/:bonusId",
    name: "ClubDetail",
    component: ClubDetail,
  },
  {
    path: "/Prize",
    name: "ClubPrize",
    component: ClubPrize,
  },
  {
    path: "/ScoreDetail",
    name: "ScoreDetail",
    component: ScoreDetail,
  },
  {
    path: "/CarFinesServices",
    name: "CarFinesServices",
    component: CarFinesServices,
  },
  {
    path: "/FreewayTollsServices",
    name: "FreewayTollsServices",
    component: FreewayTollsServices,
  },
  {
    path: "/TehranTollsServices",
    name: "TehranTollsServices",
    component: TehranTollsServices,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
